import { toast } from 'react-toastify';

import { IconSuccessfulSolid24 } from '../icons/ic-successfulSolid';

import { showToast } from './toast-helper';

export function copyToClipboard(text: string, confirmationToastMessage?: string, onSuccess?: () => void): void {
    if (typeof document !== 'undefined' && document.body) {
        try {
            const textAreaTmp = document.createElement('textarea');
            try {
                document.activeElement?.appendChild(textAreaTmp);
            } catch {
                document.body.appendChild(textAreaTmp);
            }
            textAreaTmp.id = '__tmp__copy__to__clipboard__elem';
            textAreaTmp.style.position = 'fixed';
            textAreaTmp.style.left = '-9999';
            textAreaTmp.style.top = '-9999';
            textAreaTmp.style.opacity = '0';
            textAreaTmp.innerText = text;
            textAreaTmp.focus();
            textAreaTmp.select();
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            document.execCommand('copy');
            document.getElementById('__tmp__copy__to__clipboard__elem')?.remove();
        } catch {
            navigator.clipboard.writeText(text);
        }

        if (confirmationToastMessage) {
            showToast({
                toastType: toast.info,
                messageTitle: confirmationToastMessage,
                messageIcon: (
                    <IconSuccessfulSolid24
                        fill="#40E587"
                        foregroundcolor="black"
                    />
                )
            });
        }

        if (onSuccess) {
            onSuccess();
        }
    }
}
